import React from 'react'
import { Pill } from '../../../../shared/sso-workspace/pill'
import { formatAgo, formatDateTime } from '../../../../shared/sso-workspace/format'
import { useOrganizationName } from '../../../../shared/org-search/use-organization-names'
import { channelLabel, deliveryStatusLabel, deliveryStatusTone, eventStatusLabel, eventStatusTone, providerLabel } from '../../../../shared/notify/words'

// AG Grid cell renderers the notify grids share (ColumnFormat render).
export const agoCell = row => (row.value ? <span title={formatDateTime(row.value)}>{formatAgo(row.value)}</span> : '')

export const monoCell = row => (row.data && row.value !== undefined && row.value !== null && row.value !== '' ? <span className="sw-mono small">{String(row.value)}</span> : '')

export const channelCell = row => (row.data ? channelLabel(row.value) : '')

export const providerCell = row => (row.data ? providerLabel(row.value) : '')

export const deliveryStatusCell = row =>
  row.data ? <Pill tone={deliveryStatusTone(row.value)} title={row.data.lastError || row.data.skipReason || undefined}>{deliveryStatusLabel(row.value)}</Pill> : ''

export const eventStatusCell = row =>
  row.data ? <Pill tone={eventStatusTone(row.value)} title={row.data.failedReason || undefined}>{eventStatusLabel(row.value)}</Pill> : ''

// An organization by id, named once content's search knows it.
const OrganizationName = ({ id, fallback }) => {
  const name = useOrganizationName(id)
  return name || fallback || `Organization ${id}`
}

export const organizationCell = row => {
  if (!row.data) return ''
  if (!row.value) return <span className="sw-hint">None</span>
  return <OrganizationName id={row.value} fallback={row.data.organizationName} />
}
